// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-light: #f4f9ff;
  --color-white: #ffffff;
  --color-white-2: #FBFCFE;
  --color-primary: #1f68d6;
  --color-primary-2: #3b7ee3;
  --color-primary-3: #ccedff;
  --color-primary-4: #003c97;
  --color-primary-5: #0042A6;
  --color-primary-7: #c1daff;
  --color-primary-8: #97c1ff;
  --color-primary-09: #CCEDFF;
  --color-mima-light: #EEF2F5;
  --color-error: #e12f2f;
  --color-success: #66b032;
  --color-green: #569755;
  --color-green-2: #92e391;
  --color-green-3: #d3eace;
  --color-yellow: #e7d788;
  --color-yellow-2: #ffaa00;
  --color-yellow-3: #8f4f00;
  --color-light-red: #f7d1cd;
  --color-deep-red: #9f0000;
  --color-grey: #b3b3c5;
  --color-grey-2: #d1d1d1;
  --color-grey-3: #e0e9f3;
  --color-grey-4: #D1D1D1;
  --color-grey-5: #EBEBF5;
  --color-grey-6: #9898AB;
  --color-table-grey: #fafafc;
  --color-table-grey-1: #f4f4fc;
  --color-dark: #4a4a68;
  --color-dark-2: #1a1a42;
  --color-dark-3: #696365;
  --color-dark-6: #2a2828;
  --color-disabled: #C0C0C0;
  --color-light-blue: #EBF2FF;
  --color-light-blue-2: #D4E5FF;
  --color-light-blue-3: #E7F3FE;
  --color-dark-yellow: #7E6E1F;
  --color-light-brown: #f4f5f6;
  --color-light-green: #E4FFEC;
  --color-light-yellow: #FFF5D7;
  --color-light-red: #FFE8E8;
  --color-light-grey: #F3F3FF;
  --color-admin: #112855;
  --color-admin-2: #071530;
  --color-admin-3: #020710;
  --default-font-size: 1.8rem;
  --default-font-h1: 6.4rem;
  --default-font-h2: 4rem;
  --default-font-h3: 3.2rem;
  --default-font-subtitle: 2.4rem;
  --default-font-small: 1.4rem;
  --default-font-xsmall: 1.2rem;
}

.LeftSideSlider_slider__img__7gqVT {
  height: 32.8rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables/_variables.scss","webpack://./src/assets/styles/pageComponents/LeftSideSlider.module.scss"],"names":[],"mappings":"AAAA;EAEC,sBAAA;EACA,sBAAA;EACA,wBAAA;EAEA,wBAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EAEA,sBAAA;EACA,wBAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EAEA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EAEA,sBAAA;EACA,wBAAA;EACA,wBAAA;EAGA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,+BAAA;EACA,4BAAA;EACA,6BAAA;ACTD;;AApDE;EACE,eAAA;AAuDJ","sourcesContent":[":root {\n\t//COLORS\n\t--color-light: #f4f9ff;\n\t--color-white: #ffffff;\n\t--color-white-2: #FBFCFE;\n\n\t--color-primary: #1f68d6;\n\t--color-primary-2: #3b7ee3;\n\t--color-primary-3: #ccedff;\n\t--color-primary-4: #003c97;\n\t--color-primary-5: #0042A6;\n\t--color-primary-7: #c1daff;\n\t--color-primary-8: #97c1ff;\n\t--color-primary-09: #CCEDFF;\n\t--color-mima-light: #EEF2F5;\n\n\t--color-error: #e12f2f;\n\t--color-success: #66b032;\n\t--color-green: #569755;\n\t--color-green-2: #92e391;\n\t--color-green-3: #d3eace;\n\t--color-yellow: #e7d788;\n\t--color-yellow-2: #ffaa00;\n\t--color-yellow-3: #8f4f00;\n\t--color-light-red: #f7d1cd;\n\t--color-deep-red: #9f0000;\n\n\t--color-grey: #b3b3c5;\n\t--color-grey-2: #d1d1d1;\n\t--color-grey-3: #e0e9f3;\n\t--color-grey-4: #D1D1D1;\n\t--color-grey-5: #EBEBF5;\n\t--color-grey-6: #9898AB;\n\t--color-table-grey: #fafafc;\n\t--color-table-grey-1: #f4f4fc;\n\n\t--color-dark: #4a4a68;\n\t--color-dark-2: #1a1a42;\n\t--color-dark-3: #696365;\n\t--color-dark-6: #2a2828;\n\n\t--color-disabled: #C0C0C0;\n\t--color-light-blue: #EBF2FF;\n\t--color-light-blue-2: #D4E5FF;\n\t--color-light-blue-3: #E7F3FE;\n\n\t--color-dark-yellow: #7E6E1F;\n\t--color-light-brown: #f4f5f6;\n\t--color-light-green: #E4FFEC;\n\t--color-light-yellow: #FFF5D7;\n\t--color-light-red: #FFE8E8;\n\t--color-light-grey: #F3F3FF;\n\n\t--color-admin: #112855;\n\t--color-admin-2: #071530;\n\t--color-admin-3: #020710;\n\n\t// FONT\n\t--default-font-size: 1.8rem;\n\t--default-font-h1: 6.4rem;\n\t--default-font-h2: 4rem;\n\t--default-font-h3: 3.2rem;\n\t--default-font-subtitle: 2.4rem;\n\t--default-font-small: 1.4rem;\n\t--default-font-xsmall: 1.2rem;\n}\n\n//COLORS\n$color-light: #f4f9ff;\n$color-white: #ffffff;\n$color-white-2: #FBFCFE;\n\n$color-primary: #1f68d6;\n$color-primary-2: #3b7ee3;\n$color-primary-3: #ccedff;\n$color-primary-4: #003c97;\n$color-primary-7: #c1daff;\n$color-primary-09: #CCEDFF;\n\n$color-error: #e12f2f;\n$color-success: #66b032;\n$color-green: #569755;\n$color-green-2: #92e391;\n$color-yellow: #e7d788;\n$color-light-red: #f7d1cd;\n\n$color-grey: #b3b3c5;\n$color-grey-2: #d1d1d1;\n$color-grey-3: #e0e9f3;\n$color-grey-4: #D1D1D1;\n$color-grey-6:#9898AB;\n\n$color-dark: #4a4a68;\n$color-dark-3: #696365;\n$color-dark-6: #2a2828;\n\n// FONT\n$default-font-size: 1.8rem;\n$default-font-h1: 6.4rem;\n$default-font-h2: 4rem;\n$default-font-h3: 3.2rem;\n$default-font-subtitle: 2.4rem;\n$default-font-small: 1.4rem;\n\n// SHADOWS\n$shadow-dark: 0 2rem 6rem rgba(0, 0, 0, 0.3);\n$shadow-light: 0 2rem 5rem rgba(0, 0, 0, 0.06);\n","@import \"../variables/variables\";\n\n.slider {\n  &__img {\n    height: 32.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"slider__img": `LeftSideSlider_slider__img__7gqVT`
};
export default ___CSS_LOADER_EXPORT___;
